<template>
  <div class="sidebar">
    <ul>
      <li>
        <span>تعداد  </span>
        <span class="bold">{{ count }} </span>
      </li>
      <li>
        <span>قیمت </span>
        <span><span class="bold">{{ formatNumber(sums) }} </span> <small>تومان</small></span>
      </li>
      <li v-if="(discounts > 0)">
        <span>تخفیف </span>
        <span class="red"><span class="bold">{{ formatNumber(discounts) }} </span> <small>تومان</small></span>
      </li>
      <li id="delivery-price">
        <span>هزینه ارسال </span>
        <span>{{ formatNumber(deliveryPrice) }}</span>
      </li>
      <li class="sum-price">
        <span class="black">جمع </span>
        <span class="black"><span class="bold">{{ formatNumber(payment) }} </span> <small>تومان</small></span>
      </li>
    </ul>
    <b-col class=" text-center">
      <b-btn pill variant="primary" @click="submit" class="mt-2">{{ caption }}</b-btn>
    </b-col>

  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";


export default {
  name: "ShippingCardSide",
  props: ['items', 'submit', 'caption', 'sidebarData', 'deliveryPrice', 'deliveryBoundary'],
  computed: {
    count() {
      var s = 0
      this.items.forEach((element, key) => {
        s += element.quantity
      });
      return s;
    },
    sums() {
      return parseInt(this.sidebarData.total_amount)
    },
    discounts() {
      return parseInt(this.sidebarData.offer_amount)
    },
    payment() {
      return this.sidebarData.paying_amount
    },
  },
  methods: {
    formatNumber,
    setOfferCondition() {
      if (this.payment > this.deliveryBoundary || this.sidebarData.delivery_amount == 0) {
        document.getElementById('delivery-price').style.textDecoration = "line-through";
      } else {
        document.getElementById('delivery-price').style.textDecoration = "none";
      }
    }
  },
  mounted() {
    this.setOfferCondition()
  },
  watch: {
    sidebarData: {
      handler: function (newValue, oldValue) {
        this.setOfferCondition();
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.sidebar {
  font-size: 10pt;
  background: white;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 2px 4px 10px #eeeeee;
}

.sidebar ul {
  list-style: none;
}

.sidebar li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 6px 0;
  color: #777;
}

.sidebar li.sum-price {
  padding-top: 5px;
  border-top: 1px solid #eee;
}


.red {
  color: red;
}

.black {
  color: black;
}

.bold {
  font-weight: bolder;
  font-size: 12pt;
}
</style>